const path = require('path');
const files = require.context('.', false, /\.js$/);
const modules = {};

files.keys().forEach((key) => {
  if (key === './index.js') return;
  const name = path.basename(key, '.js');
  modules[name] = files(key).default || files(key);
});
export default modules;
